import TeamSurvivorEntryScheduled from '../../../components/TeamSurvivorEntryScheduled/TeamSurvivorEntryScheduled';
import ConfirmationModalContextProvider from '../../../../common/context/GamecenterConfirmationModalContext/ConfirmationModalContextProvider';
import GamecenterEditedContestModal from '../../../../common/components/GamecenterEditedContestModal/GamecenterEditedContestModal';
import useTeamEntriesScheduled from '../../../../team/hooks/useTeamEntriesScheduled';
import GamecenterEntriesPageScheduled from '../../../../common/components/GamecenterEntriesPageScheduled/GamecenterEntriesPageScheduled';

function TeamSurvivorEntriesPageScheduled() {
  const { isLoading, error, entries, hasNextPage, isFetchingNextPage, fetchNextPage } =
    useTeamEntriesScheduled();

  return (
      <ConfirmationModalContextProvider>
        <GamecenterEditedContestModal />
        <GamecenterEntriesPageScheduled
          isLoading={isLoading}
          error={error}
          entries={entries}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
          EntryComponent={TeamSurvivorEntryScheduled}
        />
      </ConfirmationModalContextProvider>
  );
}

export default TeamSurvivorEntriesPageScheduled;
